(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3707],{

/***/ 11534:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-front.10386668.svg","height":30,"width":21});

/***/ }),

/***/ 10108:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-plan.e3ef5f8e.svg","height":30,"width":21});

/***/ }),

/***/ 3089:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/2D-side.8db96089.svg","height":30,"width":21});

/***/ }),

/***/ 59363:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D-BIM.97bd8cd9.svg","height":30,"width":21});

/***/ }),

/***/ 65317:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/3D.ed0a4d74.svg","height":30,"width":20});

/***/ }),

/***/ 70315:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/PDF-ANN.a1a3ec81.svg","height":27,"width":22});

/***/ }),

/***/ 24425:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/cutout.a8f7a575.svg","height":30,"width":21});

/***/ }),

/***/ 93056:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/* harmony default export */ __webpack_exports__["Z"] = ({"src":"/_next/static/media/parts-diagram.68741125.svg","height":17,"width":14});

/***/ }),

/***/ 40577:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9473);
/* harmony import */ var react_device_detect__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(85518);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(66261);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(27361);
/* harmony import */ var lodash_get__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(lodash_get__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var react_lazy_load__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(25043);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(93967);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_7___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_7__);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(41609);
/* harmony import */ var lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_9___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_9__);
/* harmony import */ var _constants_config__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19514);
/* harmony import */ var _hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(18216);
/* harmony import */ var _hooks_usePrevious__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(97349);
/* harmony import */ var _utils_helper__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(27514);
/* harmony import */ var _components_Search_v1_ProductsTab_helper__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(34955);
/* harmony import */ var _store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(54127);
/* harmony import */ var _store_features_productListSlice__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(42286);
/* harmony import */ var _store_features_authSlice__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(2693);
/* harmony import */ var _components_ProductList_v2_Sort_index_module_scss__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(58088);
/* harmony import */ var _components_ProductList_v2_Sort_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_Sort_index_module_scss__WEBPACK_IMPORTED_MODULE_23__);
/* harmony import */ var _components_ProductList_v2_Filter_index_module_scss__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(68167);
/* harmony import */ var _components_ProductList_v2_Filter_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_Filter_index_module_scss__WEBPACK_IMPORTED_MODULE_24__);
/* harmony import */ var _components_Shared_Search_v1_InspirationTile__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54455);
/* harmony import */ var _components_ProductList_v2_ProductListView_StickyNav_stickyNavHeader__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(79378);
/* harmony import */ var _components_ProductList_v2_ProductListView_Pagination__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(57633);
/* harmony import */ var _components_ProductList_v2_Filter__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(61304);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(55266);
/* harmony import */ var _components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default = /*#__PURE__*/__webpack_require__.n(_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22__);
/* harmony import */ var _components_Shared_Search_v1_InspirationTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(68993);
/* harmony import */ var _components_Shared_Search_v1_InspirationTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default = /*#__PURE__*/__webpack_require__.n(_components_Shared_Search_v1_InspirationTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25__);
/* harmony import */ var _components_Search_v1_InspirationTab_index_module_scss__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(28077);
/* harmony import */ var _components_Search_v1_InspirationTab_index_module_scss__WEBPACK_IMPORTED_MODULE_26___default = /*#__PURE__*/__webpack_require__.n(_components_Search_v1_InspirationTab_index_module_scss__WEBPACK_IMPORTED_MODULE_26__);



























const InspirationTab = (param)=>{
    let { page ="" , type ="" , searchKeyword ="" , totalResults =0 , leadTimeData , displayShare , displayPrint , isLandscape , pageId , fquery , knowledgeArticleUrl , translate , staticTexts ={} , onSearch =()=>{} , productsPerPage , totalSearchResults , marketParamValues =[] , profileName ="" , lwAppName ="" , isSearchTab =true , isFaq =false , showTotal =true  } = param;
    var ref;
    const [width] = (0,_hooks_useWindowResize__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z)();
    const dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useDispatch */ .I0)();
    const selectRow = false;
    const [showFilter, setShowFilter] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(width >= 1024 ? true : false);
    const [rowCols, setRowCols] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(width < 1024 ? 1 : 3);
    const [curRows, setCurRows] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(30);
    const [start, setStart] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0);
    const filterModalWindow = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const [selectedSort, setSelectedSort] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)({});
    const [filterQueries, setFilterQueries] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const [siteName, setSiteName] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)("");
    const [dataPopulated, setDataPopulated] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    var ref1;
    const [scrollToSku, setScrollToSku] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)((ref1 = sessionStorage === null || sessionStorage === void 0 ? void 0 : sessionStorage.plpScrollSku) !== null && ref1 !== void 0 ? ref1 : "");
    const [isLoadMore, setIsLoadMore] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        const selectedSortItem = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .getSortItemBasedOnURL */ .KE)(staticTexts, {
            name: "Featured"
        });
        setSelectedSort(selectedSortItem);
    }, []);
    const [isFusionLoaded, setIsFusionLoaded] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const [newData, setNewData] = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)([]);
    const prevRows = (0,_hooks_usePrevious__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z)(curRows);
    const SEARCH = window && window.location.search;
    const router = (0,next_router__WEBPACK_IMPORTED_MODULE_9__.useRouter)();
    const { searchDetails ={}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .searchState */ .uv);
    const { fusion: searchFusion = {}  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectProductListState */ .rv).plp;
    const { data =[] , total , facets ={} , facetLabels , colors  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_16__/* .selectProductListState */ .rv).plp;
    const { access_token: accessToken  } = (0,react_redux__WEBPACK_IMPORTED_MODULE_2__/* .useSelector */ .v9)(_store_features_authSlice__WEBPACK_IMPORTED_MODULE_17__/* .selectAuthState */ ._9);
    const retainedFilters = searchDetails.keyword === searchKeyword && ((ref = searchDetails[type]) === null || ref === void 0 ? void 0 : ref.filters) ? searchDetails[type].filters : [];
    const persona = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .getUserPersona */ .shu)();
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        (0,_constants_config__WEBPACK_IMPORTED_MODULE_10__/* .getConfig */ .i)().then((config)=>{
            const brand = lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(config, "general.siteName");
            setSiteName(brand);
        });
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (type === "Resources" && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(leadTimeData)) {
            setNewData([
                leadTimeData,
                ...data
            ]);
        } else {
            setNewData(data);
        }
    }, [
        data,
        leadTimeData,
        type
    ]);
    const filterClass = classnames__WEBPACK_IMPORTED_MODULE_7___default()({
        "product-listing__filter": true,
        "product-listing__filter--hide": !showFilter,
        "product-listing__filter--modal": showFilter
    });
    const tileClass = classnames__WEBPACK_IMPORTED_MODULE_7___default()({
        "product-listing__tile-col": true,
        "product-listing__tile-col--full-width": !showFilter
    });
    const sorts = [
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.featured
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.atoz,
            query: "title_s+asc"
        },
        {
            name: staticTexts === null || staticTexts === void 0 ? void 0 : staticTexts.ztoa,
            query: "title_s+desc"
        }
    ];
    const executeScroll = ()=>{
        react_scroll__WEBPACK_IMPORTED_MODULE_4__/* .scroller.scrollTo */ .OK.scrollTo("products-tab", {
            duration: 1500,
            delay: 0,
            smooth: "easeInOutQuart"
        });
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        switch(true){
            case width > 1024:
                setRowCols(3);
                break;
            case width < 668:
                setRowCols(2);
                break;
            default:
                setRowCols(3);
        }
    }, [
        isLandscape,
        width
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (accessToken && filterQueries != null) {
            // will trigger for faq details page
            if (pageId) {
                generateListingUrl(false, true);
            // will trigger from onLoadMore
            } else if (start) {
                generateListingUrl(isLoadMore, false);
            // Will trigger when user coming back from PDP page
            } else if (start == 0 && scrollToSku) {
                setScrollToSku("");
                generateListingUrl(false, true);
            } else if (start == 0 && curRows && !!prevRows && prevRows > curRows) {
                generateListingUrl(false, true);
            } else if (start == 0 && curRows) {
                generateListingUrl(false, false);
            }
        }
    }, [
        accessToken,
        start,
        curRows,
        selectedSort,
        filterQueries,
        pageId
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        // To scrollup the product list on back
        if (dataPopulated) (0,_components_Search_v1_ProductsTab_helper__WEBPACK_IMPORTED_MODULE_14__/* .scrollToProduct */ .C1)();
    }, [
        dataPopulated
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let filterQuery = [];
        if (!lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(searchFusion) && accessToken && !isFusionLoaded) {
            setIsFusionLoaded(true);
            if (retainedFilters.length > 0) {
                filterQuery = retainedFilters;
            } else {
                filterQuery = (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .getAllFilterQueries */ .ud4)({
                    attributeName: ""
                }, searchFusion, marketParamValues);
                dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchKeyword */ .Ec)(searchKeyword));
                dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchFilter */ .Qf)({
                    queries: filterQuery,
                    key: type
                }));
                (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .retainSearchQueryParams */ .mSA)(type);
            }
            if (filterQuery.length) {
                setFilterQueries(filterQuery);
            }
        }
    }, [
        searchFusion,
        accessToken
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (pageId) {
            setStart(0);
        }
    }, [
        pageId
    ]);
    const onRows = (rows)=>{
        setStart(0);
        setCurRows(rows);
    };
    const onLoadMore = ()=>{
        setStart(start + curRows);
        setIsLoadMore(true);
    };
    const onSort = (selectedSort)=>{
        setStart(0);
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .replaceSearchUrl */ .CjH)("sort", selectedSort.query);
        if (!isFaq) (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .replaceSearchUrl */ .CjH)("tab", type);
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .retainSearchQueryParams */ .mSA)(type);
        setSelectedSort(selectedSort);
    };
    const generateListingUrl = function(update) {
        let enableScroll = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, queries = arguments.length > 2 ? arguments[2] : void 0;
        let callStart = 0;
        if (!queries && retainedFilters.length > 0) {
            setFilterQueries(retainedFilters);
            queries = retainedFilters;
        } else {
            queries = filterQueries;
            callStart = start;
            dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchKeyword */ .Ec)(searchKeyword));
            dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchFilter */ .Qf)({
                queries: filterQueries,
                key: type
            }));
        }
        if (pageId && SEARCH) {
            const url = window.location.pathname;
            const articlePathname = url.split("/").pop();
            router.push("".concat(url.replace("/".concat(articlePathname), "")).concat(SEARCH));
            return;
        }
        const fq = [
            fquery
        ];
        queries.forEach((q)=>{
            const tag = '{!tag="'.concat(q.facet, '"}');
            if (!q.facet.match(/^\*{2}/)) {
                fq.push(encodeURIComponent("".concat(tag + q.facet, ':("').concat(q.value.join('" OR "'), '")')));
                return;
            }
            fq.push("".concat(q.facet.replace(/^\*{2}/, ""), ':("').concat(encodeURIComponent(q.value.join('","')), '")'));
        });
        const query = {
            fq,
            rows: curRows,
            start: isLoadMore ? callStart : 0
        };
        if (selectedSort.name !== staticTexts.featured) {
            if (selectedSort.name) {
                query.sort = selectedSort.query;
            }
        }
        const fl = [
            "id",
            "url_s",
            "title_s",
            "pageTitle_s",
            "eyeBrowText_s",
            "thumbNailImage_s",
            "externalRedirectUrl_s",
            "contentSource_s",
            "searchDescription_s",
            "layoutItems.Article_Summary__c.value_s",
            "leadTime_b",
            "page_description_content_s",
            "Sale.".concat(persona, ".Details_ss")
        ];
        const queryParams = {
            q: searchKeyword,
            fl: fl.join(","),
            ...query,
            displaytype: "search",
            update,
            isFaq
        };
        // for handling support/help-and-faq
        if (profileName) {
            queryParams["profileName"] = profileName;
            queryParams["collections"] = lwAppName.toLowerCase();
            queryParams["q"] = searchKeyword !== null && searchKeyword !== void 0 ? searchKeyword : "*:*";
        }
        // for handling support/help-and-faq details page
        if (pageId) {
            queryParams["start"] = 0;
        }
        if (enableScroll) setDataPopulated(false);
        dispatch((0,_store_features_productListSlice__WEBPACK_IMPORTED_MODULE_16__/* .getProducts */ .Xp)({
            ...queryParams
        })).then(()=>{
            if (enableScroll) setDataPopulated(true);
        }).catch(()=>{
            if (enableScroll) setDataPopulated(false);
        });
    };
    if (pageId && data[0]) {
        (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .addADALink */ .i6z)(document.getElementsByClassName("knowledge-article-detail-section")[0], {
            translate: translate
        });
    }
    const handleBackToTop = ()=>{
        var ref;
        window.scrollTo({
            top: 0,
            behavior: "smooth"
        });
        (ref = document.getElementById("kf-product-list-tile-details-0")) === null || ref === void 0 ? void 0 : ref.focus();
    };
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        if (showFilter && (width < 992 || react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isMobile */ .tq || react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isTablet */ .Em)) {
            var ref;
            filterModalWindow === null || filterModalWindow === void 0 ? void 0 : (ref = filterModalWindow.current) === null || ref === void 0 ? void 0 : ref.focus();
        } else if (!showFilter && (width < 992 || react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isMobile */ .tq || react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isTablet */ .Em)) {
            var ref1;
            (ref1 = document.getElementById("showFilter")) === null || ref1 === void 0 ? void 0 : ref1.focus();
        }
    }, [
        showFilter
    ]);
    /**
   * Adds two numbers together.
   * @param {e} e The first number.
   */ function handleKeyPress(e) {
        if (width < 992) {
            const focusElements = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"]), button:not([disabled]) [role="button]:not([hidden=true])';
            const focusContent = filterModalWindow.current.querySelectorAll(focusElements);
            const firstElem = focusContent[0];
            const lastElem = focusContent[focusContent.length - 1].disabled ? focusContent[focusContent.length - 2] : focusContent[focusContent.length - 1];
            if (e.key === "Escape") {
                setShowFilter(false);
            }
            if (e.key === "Tab") {
                if (e.shiftKey && (document.activeElement === firstElem || document.activeElement === filterModalWindow.current)) {
                    e.preventDefault();
                    lastElem.focus();
                }
                if (!e.shiftKey && document.activeElement === lastElem) {
                    e.preventDefault();
                    firstElem.focus();
                }
            }
        }
    }
    const handleFilter = (queries)=>{
        setIsLoadMore(false);
        dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchKeyword */ .Ec)(searchKeyword));
        dispatch((0,_store_features_searchSlice__WEBPACK_IMPORTED_MODULE_15__/* .setSearchFilter */ .Qf)({
            queries,
            key: type
        }));
        setFilterQueries(queries);
        (0,_components_Search_v1_ProductsTab_helper__WEBPACK_IMPORTED_MODULE_14__/* .scrollToFirstProduct */ .nj)(isFaq);
    };
    const isAssetResource = (content)=>{
        return type === "Resources" && !lodash_isEmpty__WEBPACK_IMPORTED_MODULE_8___default()(content) && content.toLowerCase() === "asset";
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "".concat((_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default()) === null || (_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default()) === void 0 ? void 0 : (_components_ProductList_v2_ProductListView_index_module_scss__WEBPACK_IMPORTED_MODULE_22___default().productListWrapper), "  ").concat((_components_ProductList_v2_Sort_index_module_scss__WEBPACK_IMPORTED_MODULE_23___default().productListingSearchWrapper), " ").concat((_components_ProductList_v2_Filter_index_module_scss__WEBPACK_IMPORTED_MODULE_24___default().productListingFilterWrapper), " ").concat((_components_Shared_Search_v1_InspirationTile_index_module_scss__WEBPACK_IMPORTED_MODULE_25___default().inspirationTileWrapper), " ").concat((_components_Search_v1_InspirationTab_index_module_scss__WEBPACK_IMPORTED_MODULE_26___default().inspirationWrapper)),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "product-listing",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_StickyNav_stickyNavHeader__WEBPACK_IMPORTED_MODULE_19__["default"], {
                    showFilter: showFilter,
                    rowCols: rowCols,
                    setShowFilter: setShowFilter,
                    setRowCols: setRowCols,
                    staticTexts: staticTexts,
                    sorts: sorts,
                    selectedSort: selectedSort,
                    handleSort: onSort,
                    totalResults: totalSearchResults,
                    isSearchTab: isSearchTab,
                    searchKeyword: searchKeyword,
                    onSearch: onSearch,
                    page: page,
                    type: type,
                    pageId: pageId,
                    showTotal: showTotal,
                    isFaq: isFaq
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    className: "container kf-react-plp-container product-listing__tiles",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "product-listing__row d-block",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "filter-col",
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: filterClass,
                                    "aria-modal": true,
                                    ref: filterModalWindow,
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                        className: "product-listing__filter--sticky",
                                        "aria-hidden": !showFilter,
                                        onKeyDown: handleKeyPress,
                                        children: facets && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_Filter__WEBPACK_IMPORTED_MODULE_21__["default"], {
                                            tabIndex: "0",
                                            hidePriceRange: true,
                                            page: page || "",
                                            texts: staticTexts,
                                            facetData: facets,
                                            facetLabels: facetLabels,
                                            currFilters: filterQueries,
                                            onFilter: handleFilter,
                                            sort: sorts,
                                            selectedSort: selectedSort,
                                            onSortChange: onSort,
                                            displayShare: true,
                                            displayPrint: true,
                                            close: setShowFilter,
                                            colors: colors,
                                            handleScroll: executeScroll,
                                            addToUrl: siteName !== null && siteName !== void 0 ? siteName : false,
                                            showFilter: showFilter,
                                            showSort: width <= 991,
                                            selectedFilterCount: filterQueries && filterQueries.reduce((acc, item)=>{
                                                return acc + item.value.length;
                                            }, 0),
                                            totalResults: total,
                                            isLandscape: isLandscape,
                                            type: type || "Inspiration",
                                            isFaq: isFaq,
                                            wrapperClass: ".inspiration-tile-box"
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: tileClass,
                                    children: [
                                        pageId && newData[0] && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row row-cols-".concat(react_device_detect__WEBPACK_IMPORTED_MODULE_3__/* .isMobile */ .tq ? 1 : 9),
                                            role: "list",
                                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "knowledge-article-detail-section",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                                                    className: "title",
                                                    children: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(newData[0], "title_s", "")
                                                })
                                            })
                                        }),
                                        !pageId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                            className: "row row-cols-".concat(rowCols),
                                            children: newData.map((element, i)=>{
                                                let tileData = {};
                                                if (type === "Help") {
                                                    var _id;
                                                    const id = (_id = element.id) !== null && _id !== void 0 ? _id : "";
                                                    var _urlName_s;
                                                    const articlePath = (_urlName_s = element.urlName_s) !== null && _urlName_s !== void 0 ? _urlName_s : "";
                                                    var _pageTitle_s, ref;
                                                    tileData = {
                                                        id: id,
                                                        contentUrl: "".concat(knowledgeArticleUrl, "/").concat(articlePath),
                                                        categoryName: "",
                                                        title: (_pageTitle_s = element.pageTitle_s) !== null && _pageTitle_s !== void 0 ? _pageTitle_s : element.title_s,
                                                        subTitle: "",
                                                        description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .sanitizeText */ .oOy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "layoutItems.Article_Summary__c.value_s", "")),
                                                        imageUrl: "",
                                                        leadTime_b: (ref = element === null || element === void 0 ? void 0 : element.leadTime_b) !== null && ref !== void 0 ? ref : false,
                                                        page_description_content_s: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "page_description_content_s", "")
                                                    };
                                                } else {
                                                    let assetResource_flag = isAssetResource(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "contentSource_s", ""));
                                                    var _pageTitle_s1, ref1;
                                                    tileData = {
                                                        contentUrl: assetResource_flag ? lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "externalRedirectUrl_s", "") : lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "url_s", ""),
                                                        categoryName: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "eyeBrowText_s", ""),
                                                        title: (_pageTitle_s1 = element.pageTitle_s) !== null && _pageTitle_s1 !== void 0 ? _pageTitle_s1 : element.title_s,
                                                        subTitle: "",
                                                        description: (0,_utils_helper__WEBPACK_IMPORTED_MODULE_13__/* .sanitizeText */ .oOy)(lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "searchDescription_s", "")),
                                                        imageUrl: assetResource_flag ? lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "url_s", "") : lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "thumbNailImage_s", ""),
                                                        leadTime_b: (ref1 = element === null || element === void 0 ? void 0 : element.leadTime_b) !== null && ref1 !== void 0 ? ref1 : false,
                                                        page_description_content_s: lodash_get__WEBPACK_IMPORTED_MODULE_5___default()(element, "page_description_content_s", "")
                                                    };
                                                }
                                                const isFocusTo = selectRow ? start > 0 && start === i || (curRows > 30 && start === 0 ? i === curRows - 30 : start >= 30 ? i === start + 1 : i === 0) ? true : false : false;
                                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "col-12",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                            className: "col-12 px-0 inspiration-tile-box ".concat(isFocusTo ? "focussed" : ""),
                                                            id: "kf-inspiration-".concat(i),
                                                            role: "listitem",
                                                            tabIndex: "0",
                                                            children: i < 3 ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Search_v1_InspirationTile__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                id: "kf-inspiration-tile-".concat(i),
                                                                data: tileData,
                                                                texts: staticTexts,
                                                                lite: !isLandscape ? rowCols === 2 : false,
                                                                type: type,
                                                                highlightText: searchKeyword,
                                                                page: page
                                                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_lazy_load__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                                                className: "kf-lazyload-wrapper",
                                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_Shared_Search_v1_InspirationTile__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z, {
                                                                    id: "kf-inspiration-tile-".concat(i),
                                                                    data: tileData,
                                                                    texts: staticTexts,
                                                                    lite: !isLandscape ? rowCols === 2 : false,
                                                                    type: type,
                                                                    highlightText: searchKeyword,
                                                                    page: page
                                                                })
                                                            })
                                                        })
                                                    }, i)
                                                }, i);
                                            })
                                        }),
                                        !pageId && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_ProductList_v2_ProductListView_Pagination__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z, {
                                            displayPrint: displayPrint,
                                            staticTexts: staticTexts,
                                            displayShare: displayShare,
                                            curRows: curRows,
                                            productsPerPage: productsPerPage,
                                            totalResults: total,
                                            onRows: onRows,
                                            handleBackToTop: handleBackToTop,
                                            width: width,
                                            isSearchTab: true,
                                            page: page,
                                            type: type,
                                            data: newData,
                                            onLoadMore: onLoadMore,
                                            removeLoadAnimation: isFaq
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (InspirationTab);


/***/ }),

/***/ 54455:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_InspirationTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(293);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./src/components/Shared/Search/v1/InspirationTile/index.module.scss
var index_module = __webpack_require__(68993);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
// EXTERNAL MODULE: ./public/icons/PDF-ANN.svg
var PDF_ANN = __webpack_require__(70315);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
;// CONCATENATED MODULE: ./src/hooks/useViewport.js

const useViewport = ()=>{
    const [device, setDevice] = useState(getValues);
    /**
   * This function does the comparisons for different viewports
   * @return {Object} Object of all the viewport flags
   */ function getValues() {
        const resolution = window.innerWidth;
        const isExtraSmallScreen = resolution <= 375;
        const isSmallScreen = resolution <= 812;
        const isMediumScreen = resolution > 812 && resolution <= 1024;
        const isLargeTabView = resolution > 1024;
        const isLargeScreen = resolution >= 1024 && resolution < 1920;
        const isExtraLargeScreen = resolution >= 1920;
        return {
            isExtraSmallScreen,
            isSmallScreen,
            isMediumScreen,
            isLargeScreen,
            isExtraLargeScreen,
            isLargeTabView
        };
    }
    /**
   * Sets updated viewport flag values
   */ function handleWindowResize() {
        setDevice(getValues());
    }
    useEffect(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>{
            window.removeEventListener("resize", handleWindowResize);
        };
    }, []);
    return device;
};
/* harmony default export */ var hooks_useViewport = ((/* unused pure expression or super */ null && (useViewport)));
const useViewportWidth = ()=>{
    const [width, setWidth] = (0,react.useState)(0);
    const handleWindowResize = ()=>setWidth(window.innerWidth);
    (0,react.useEffect)(()=>{
        handleWindowResize();
        window.addEventListener("resize", handleWindowResize);
        return ()=>window.removeEventListener("resize", handleWindowResize);
    }, []);
    return width;
};

;// CONCATENATED MODULE: ./components/Shared/Search/v1/InspirationTile/index.jsx









const InspirationTile = (props)=>{
    const { data , type , page , highlightText , id , onToggle =()=>{}  } = props;
    const leadTime_b = data === null || data === void 0 ? void 0 : data.leadTime_b;
    const resizeWidth = useViewportWidth();
    const handleImageError = (e)=>{
        e.target.src = image_missing/* default.src */.Z.src;
    };
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, []);
    const getProductNavigationAnalyticsForHelpResults = (contentUrl, categoryName)=>{
        return JSON.stringify({
            eventAction: "search results product navigation",
            eventName: "search results product navigation",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "".concat((0,helper/* sanitizeTextForAnalytics */.T68)(categoryName), ":").concat((0,helper/* sanitizeTextForAnalytics */.T68)(data.title)),
            internalLinkPosition: "search results",
            internalLinkType: "search results:help tiles",
            internalLinkZoneName: "search results:help:main content area",
            internalLinkURL: contentUrl ? (contentUrl.indexOf("http") === -1 ? window.location.origin : "") + contentUrl : "n/a",
            clickInternalLinks: "true"
        });
    };
    const getProductNavigationAnalytics = (data)=>{
        const { contentUrl , categoryName  } = data;
        let alternateType;
        if (type === "help" && page === "article") {
            alternateType = "support:help and faq";
        }
        if (type === "help" && page !== "article") {
            return getProductNavigationAnalyticsForHelpResults(contentUrl, categoryName);
        }
        return JSON.stringify({
            eventAction: alternateType ? alternateType + ":article list:article" : "search results product navigation",
            eventName: alternateType ? alternateType + ":article list:article" : "search results product navigation",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: (0,helper/* sanitizeTextForAnalytics */.T68)(data.title),
            internalLinkPosition: alternateType || "search results",
            internalLinkType: alternateType ? alternateType + ":" + (0,helper/* sanitizeTextForAnalytics */.T68)(categoryName) : "search results:".concat(type === "resource" ? "resources" : type || "inspiration", " tiles"),
            internalLinkZoneName: alternateType ? alternateType + ":article list" : "search results:".concat(type === "resource" ? "resources" : type || "inspiration") + ":main content area",
            internalLinkURL: contentUrl ? (contentUrl.indexOf("http") === -1 ? window.location.origin : "") + contentUrl : "n/a",
            clickInternalLinks: "true"
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).inspirationTileWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: "inspiration-tile",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                id: id,
                tabIndex: "-1",
                target: leadTime_b ? "_blank" : "_self",
                className: "inspiration-tile__link gbh-data-layer",
                href: data.contentUrl,
                "data-gbh-data-layer": getProductNavigationAnalytics(data),
                onClick: onToggle,
                children: leadTime_b ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inspiration-tile__lead-time-container no-gutters wow animate__fadeInUp",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-tile__left-section no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inspiration-tile__left-section-container no-gutters",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-tile__left-section-container__first-coloumn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "inspiration-tile__title",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inspiration-tile__category-name",
                                                    children: data.categoryName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "inspiration-tile__article-title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                        text: (0,helper/* sanitizeText */.oOy)(data.title),
                                                        highlight: highlightText
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    resizeWidth > 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-tile__left-section-container__second-coloumn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inspiration-tile__lead-time-download-file",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                                title: (0,helper/* sanitizeText */.oOy)(data === null || data === void 0 ? void 0 : data.title),
                                                href: data === null || data === void 0 ? void 0 : data.contentUrl,
                                                target: "_blank",
                                                className: "inspiration-tile__lead-time-content",
                                                rel: "noreferrer",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                                        className: "inspiration-tile__lead-time-file",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                                className: "inspiration-tile__lead-time-pdf-file-icon",
                                                                src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                className: "inspiration-tile__lead-time-file-name",
                                                                children: "Lead time & shipping guidelines"
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                        className: "inspiration-tile__lead-time-download-icon",
                                                        src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                                    })
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-tile__right-section no-gutters",
                            children: resizeWidth < 1024 && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "inspiration-tile__lead-time-download-file",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("a", {
                                    title: (0,helper/* sanitizeText */.oOy)(data === null || data === void 0 ? void 0 : data.title),
                                    href: data === null || data === void 0 ? void 0 : data.contentUrl,
                                    target: "_blank",
                                    className: "inspiration-tile__lead-time-content",
                                    rel: "noreferrer",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "inspiration-tile__lead-time-file",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    className: "inspiration-tile__lead-time-pdf-file-icon",
                                                    src: PDF_ANN/* default */.Z === null || PDF_ANN/* default */.Z === void 0 ? void 0 : PDF_ANN/* default.src */.Z.src
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inspiration-tile__lead-time-file-name",
                                                    children: "Lead time & shipping guidelines"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                            className: "inspiration-tile__lead-time-download-icon",
                                            src: download_dark_gray/* default */.Z === null || download_dark_gray/* default */.Z === void 0 ? void 0 : download_dark_gray/* default.src */.Z.src
                                        })
                                    ]
                                })
                            })
                        })
                    ]
                }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "inspiration-tile__container no-gutters wow animate__fadeInUp",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-tile__left-section no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: "inspiration-tile__left-section-container no-gutters",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-tile__left-section-container__first-coloumn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: "inspiration-tile__title",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                    className: "inspiration-tile__category-name",
                                                    children: data.categoryName
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("h2", {
                                                    className: "inspiration-tile__article-title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                        text: (0,helper/* sanitizeText */.oOy)(data.title),
                                                        highlight: highlightText
                                                    })
                                                }),
                                                data.subTitle && /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                    className: "inspiration-tile__article-sub-title",
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                        text: (0,helper/* sanitizeText */.oOy)(data.subTitle),
                                                        highlight: highlightText
                                                    })
                                                })
                                            ]
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "inspiration-tile__left-section-container__second-coloumn",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "inspiration-tile__description",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                text: (0,helper/* sanitizeText */.oOy)(data.description),
                                                highlight: highlightText
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        data.imageUrl ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-tile__right-section no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "inspiration-tile__img",
                                src: data.imageUrl ? data.imageUrl : image_missing/* default.src */.Z.src,
                                alt: "inspiration-image",
                                onError: handleImageError
                            })
                        }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "inspiration-tile__right-section no-gutters",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                className: "inspiration-tile__img",
                                src: image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src,
                                alt: "inspiration-image",
                                onError: handleImageError
                            })
                        })
                    ]
                })
            })
        })
    });
};
/* harmony default export */ var v1_InspirationTile = (InspirationTile);


/***/ }),

/***/ 92173:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _components_core_Collapsible__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(73394);
/* harmony import */ var _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(97274);
/* harmony import */ var _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32873);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(48162);
/* harmony import */ var _components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_5__);






const Accordion = (props)=>{
    const { isOpen =false , analyticTitleData , analyticTitleCustomData , contentOverflow =false , trigger =false , children ="" , title , handleOpen , handleClose , containerElementProps , isArrow =false  } = props;
    const accordionWrapperStyle = "".concat((_components_core_Accordion_Accordion_module_scss__WEBPACK_IMPORTED_MODULE_5___default().accordionWrapper), " accordion-container");
    const CollapsibleHeader = (param)=>/*#__PURE__*/ {
        let { title  } = param;
        return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: "collapsible__header ".concat(analyticTitleData ? "gbh-data-layer" : ""),
            "data-gbh-data-layer": analyticTitleData || null,
            "data-gbh-data-layer-custom": analyticTitleCustomData || null,
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                    children: title
                }),
                !isArrow ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "plus",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "line line-2"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: "arrow",
                    "aria-hidden": true,
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: "down-arrow",
                            children: [
                                " ",
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                    src: _public_icons_arrow_down_svg__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z,
                                    alt: "Arrow Down"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "up-arrow",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: _public_icons_arrow_up_svg__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z,
                                alt: "Arrow Up"
                            })
                        })
                    ]
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: accordionWrapperStyle,
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: "collapsible-accordion",
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_core_Collapsible__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                open: isOpen,
                onTriggerOpening: handleOpen,
                onTriggerClosing: handleClose,
                containerElementProps: containerElementProps,
                overflowWhenOpen: contentOverflow ? contentOverflow : "hidden",
                openedClassName: "collapsible--open",
                tabIndex: "0",
                triggerOpenedClassName: "collapsible__trigger--open",
                trigger: trigger ? trigger : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(CollapsibleHeader, {
                    title: title
                }),
                transitionTime: 400,
                easing: "ease-in-out",
                children: children
            })
        })
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Accordion);


/***/ }),

/***/ 24719:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ v1_TechnicalTile; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./node_modules/lodash/get.js
var get = __webpack_require__(27361);
var get_default = /*#__PURE__*/__webpack_require__.n(get);
// EXTERNAL MODULE: ./utils/helper.js
var helper = __webpack_require__(27514);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 15 modules
var es = __webpack_require__(67421);
// EXTERNAL MODULE: ./src/hooks/useWindowResize.js
var useWindowResize = __webpack_require__(18216);
// EXTERNAL MODULE: ./src/components/core/Highlight/Highlight.jsx
var Highlight = __webpack_require__(293);
// EXTERNAL MODULE: ./src/components/Shared/ProductSocialShare/v1/ProductSocialShare.jsx
var ProductSocialShare = __webpack_require__(11059);
// EXTERNAL MODULE: ./public/icons/share.svg
var icons_share = __webpack_require__(66773);
// EXTERNAL MODULE: ./public/images/image-missing.png
var image_missing = __webpack_require__(36513);
// EXTERNAL MODULE: ./constants/config.js
var config = __webpack_require__(19514);
// EXTERNAL MODULE: ./src/components/PartsViewer/v1/PartsViewer.jsx
var PartsViewer = __webpack_require__(96005);
// EXTERNAL MODULE: ./src/components/core/Button/Button.jsx
var Button = __webpack_require__(82476);
// EXTERNAL MODULE: ./components/core/Accordion/Accordion.jsx
var Accordion = __webpack_require__(92173);
// EXTERNAL MODULE: ./src/components/core/Checkbox/Checkbox.jsx
var Checkbox = __webpack_require__(55511);
;// CONCATENATED MODULE: ./src/components/Search/v1/TechnicalTile/analytics.js

const technicalSpecsServicePartsAnalytics = (pageType, zone, productInfo)=>{
    const eventInfo = {
        clickInternalLinks: "true",
        eventAction: "".concat(pageType, ":main content area:").concat(zone, ":interactive parts diagram"),
        eventMsg: "n/a",
        eventName: "".concat(pageType, ":main content area:").concat(zone, ":interactive parts diagram"),
        eventStatus: "n/a",
        eventType: "navigation",
        internalLinkName: "service parts diagram",
        internalLinkPosition: pageType,
        internalLinkType: "".concat(pageType, ":navigation"),
        internalLinkURL: "n/a",
        internalLinkZoneName: "".concat(pageType, ":").concat(zone)
    };
    (0,helper/* pushAnalyticsObjToDataLayer */.zYT)(eventInfo, "cmp:click", {}, typeof productInfo === "string" ? JSON.parse(productInfo) : productInfo);
};

// EXTERNAL MODULE: ./public/icons/pdf-grey.svg
var pdf_grey = __webpack_require__(1405);
// EXTERNAL MODULE: ./public/icons/2D-plan.svg
var _2D_plan = __webpack_require__(10108);
// EXTERNAL MODULE: ./public/icons/2D-front.svg
var _2D_front = __webpack_require__(11534);
// EXTERNAL MODULE: ./public/icons/2D-side.svg
var _2D_side = __webpack_require__(3089);
// EXTERNAL MODULE: ./public/icons/3D.svg
var _3D = __webpack_require__(65317);
// EXTERNAL MODULE: ./public/icons/3D-BIM.svg
var _3D_BIM = __webpack_require__(59363);
// EXTERNAL MODULE: ./public/icons/cutout.svg
var cutout = __webpack_require__(24425);
// EXTERNAL MODULE: ./public/icons/download-dark-gray.svg
var download_dark_gray = __webpack_require__(91883);
// EXTERNAL MODULE: ./public/icons/parts-diagram.svg
var parts_diagram = __webpack_require__(93056);
;// CONCATENATED MODULE: ./src/components/Search/v1/TechnicalTile/TechAccordion.jsx

















const TechAccordion = (props)=>{
    const { data , designFiles , productInfo , sku , staticTexts , page  } = props;
    const [collapse, setCollapse] = (0,react.useState)({
        design: false,
        technical: false,
        install: false
    });
    const [dwgFiles, setDwgFiles] = (0,react.useState)([]);
    const [partsModal, setPartsModal] = (0,react.useState)({
        show: false,
        id: ""
    });
    const [loading, setLoading] = (0,react.useState)(false);
    const handleCollapse = (type, state)=>{
        setCollapse((prevCollapse)=>({
                ...prevCollapse,
                [type]: state
            }));
    };
    const techFiles = [];
    const installFiles = [];
    const partsFiles = [];
    const pdfPartsFiles = [];
    // check for technical files
    if (data["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"]) {
        techFiles.push(...(0,helper/* organizeData */.U2t)(data["ProductResource.SpecPDFFileName.resourceFullWebURL_ss"], data["ProductResource.SpecPDFFileName.resourceTitle_ss"], staticTexts.specsSheet, "PDF", "spec-file"));
    }
    if (data["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"]) {
        techFiles.push(...(0,helper/* organizeData */.U2t)(data["ProductResource.EnvironProdDecl.resourceFullWebURL_ss"], data["ProductResource.EnvironProdDecl.resourceTitle_ss"], staticTexts.envDeclaration, "PDF", "env-dec"));
    }
    // check for installation & support files
    if (data["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"]) {
        installFiles.push(...(0,helper/* organizeData */.U2t)(data["ProductResource.InstallationWithoutSPPDF.resourceFullWebURL_ss"], data["ProductResource.InstallationWithoutSPPDF.resourceTitle_ss"], staticTexts.installationGuide, "PDF", "install-guide"));
    }
    if (data["ProductResource.HomeownersGuide.resourceFullWebURL_ss"]) {
        installFiles.push(...(0,helper/* organizeData */.U2t)(data["ProductResource.HomeownersGuide.resourceFullWebURL_ss"], data["ProductResource.HomeownersGuide.resourceTitle_ss"], staticTexts.homeOwnerGuide, "PDF", "owners-guide"));
    }
    if (data["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"]) {
        pdfPartsFiles.push(...(0,helper/* organizeData */.U2t)(data["ProductResource.PartsPDFFileName.resourceFullWebURL_ss"], data["ProductResource.PartsPDFFileName.resourceTitle_ss"], staticTexts.partsDiagram, "PART"));
    }
    const handleDesignSelect = (checked, file, name)=>{
        file.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)(name);
        if (checked) setDwgFiles([
            ...dwgFiles,
            file
        ]);
        else setDwgFiles(dwgFiles.filter((item)=>item.id !== file.id));
    };
    const handleTechInfoDownload = (file)=>{
        try {
            window.open(file.url);
            addDownloadFilesAnalytics("technical", "success", "", file);
        } catch (error) {
            addDownloadFilesAnalytics("technical", "failure", "download failed");
        }
    };
    const getTechnicalFileName = (file)=>{
        var ref, ref1;
        return (0,helper/* sanitizeTextForAnalytics */.T68)("".concat((ref1 = (ref = file.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), ".").concat(file.type));
    };
    const getInstallationFileNames = (file)=>{
        var ref, ref1;
        return (0,helper/* sanitizeTextForAnalytics */.T68)("".concat((ref1 = (ref = file.title) === null || ref === void 0 ? void 0 : ref.trim()) === null || ref1 === void 0 ? void 0 : ref1.toLowerCase(), ".").concat(file.type));
    };
    const handleDesignSelectAll = (checked)=>{
        if (checked) {
            const selected = [];
            designFiles.twoDimension.plan.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("2d plan:".concat(obj.type));
                selected.push(obj);
            });
            designFiles.twoDimension.front.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("2d front:".concat(obj.type));
                selected.push(obj);
            });
            designFiles.twoDimension.side.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("2d side:".concat(obj.type));
                selected.push(obj);
            });
            designFiles.threeDimension.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("3d file:".concat(obj.type));
                selected.push(obj);
            });
            designFiles.bim.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("bim:".concat(obj.type));
                selected.push(obj);
            });
            designFiles.cutout.forEach((obj)=>{
                obj.actualName = (0,helper/* sanitizeTextForAnalytics */.T68)("cutout template:".concat(obj.type));
                selected.push(obj);
            });
            setDwgFiles(selected);
        } else setDwgFiles([]);
    };
    const getDesignFileNames = ()=>{
        const fileTypesString = [];
        if (dwgFiles === null || dwgFiles === void 0 ? void 0 : dwgFiles.length) {
            dwgFiles.forEach((fileObj)=>{
                fileTypesString.push(fileObj.actualName);
            });
        }
        return fileTypesString.join(":") || "n/a";
    };
    const getDesignFileUrl = ()=>{
        const fileUrlString = dwgFiles.map((fileObj)=>{
            var ref;
            return fileObj === null || fileObj === void 0 ? void 0 : (ref = fileObj.url) === null || ref === void 0 ? void 0 : ref.toLowerCase();
        });
        return (fileUrlString === null || fileUrlString === void 0 ? void 0 : fileUrlString.join(":")) || "n/a";
    };
    const handlePdfDownload = (e, link, title)=>{
        e.stopPropagation();
        let errMsg;
        try {
            window.open(link.trim(), "_blank");
        } catch (err) {
            errMsg = err.message;
        }
        addDownloadFilesAnalytics(title, errMsg, link.trim());
    };
    const addDownloadFilesAnalytics = (type, status, message, file)=>{
        let eventInfo;
        if (type === "design") {
            eventInfo = getDesignFilesDownloadEventInfo(status, message);
        } else if (type === "technical") {
            eventInfo = getTechnicalInfoDownloadEventInfo(status, message, file);
        } else if (type === "installation") {
            eventInfo = getInstallationSupportDownloadEventInfo(status, message, file);
        }
        const { adobeDataLayer: { getState  } = {}  } = window;
        const page = getState && getState("page") || {};
        const pI = JSON.parse(productInfo).productInfo;
        window.adobeDataLayer.push({
            event: "cmp:click",
            eventInfo,
            page,
            productInfo: pI
        });
    };
    const getTechnicalTabAccordionAnalytics = (collapseBoolean, type)=>{
        const alternateName = page === "technicalspecs" ? "technical specs" : "search results";
        return JSON.stringify({
            eventAction: "".concat(alternateName).concat(alternateName === "search results" ? ":technical" : "", ":main content area:").concat(type, " ").concat(collapseBoolean ? "collapse" : "expand"),
            eventName: "".concat(alternateName).concat(alternateName === "search results" ? ":technical" : "", ":main content area:").concat(type, " ").concat(collapseBoolean ? "collapse" : "expand"),
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "accordian " + (collapseBoolean ? "collapse" : "expand"),
            internalLinkPosition: alternateName,
            internalLinkType: alternateName + ":" + type,
            internalLinkZoneName: "".concat(alternateName).concat(alternateName === "search results" ? ":technical" : "", ":main content area"),
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        });
    };
    const getDesignFilesDownloadEventInfo = (status, message)=>{
        if (page === "technicalspecs") {
            return {
                eventAction: "technical specs:main content area:design files:download",
                eventName: "technical specs:main content area:design files:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: "download",
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs:design files",
                internalLinkZoneName: "technical specs:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true",
                fileNameAndFileType: getDesignFileNames()
            };
        } else {
            return {
                eventAction: "search results:technical:main content area:download",
                eventName: "search results:technical:main content area:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: "download",
                internalLinkPosition: "search results",
                internalLinkType: "search results:design files",
                internalLinkZoneName: "search results:technical:main content area",
                internalLinkURL: getDesignFileUrl(),
                clickInternalLinks: "true",
                fileNameAndFileType: getDesignFileNames()
            };
        }
    };
    const getTechnicalInfoDownloadEventInfo = (status, message, file)=>{
        if (page === "technicalspecs") {
            return {
                eventAction: "technical specs:main content area:technical info:download",
                eventName: "technical specs:main content area:technical info:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: getTechnicalFileName(file),
                internalLinkPosition: "tech specs",
                internalLinkType: "technical specs:technical info",
                internalLinkZoneName: "technical specs:main content area",
                internalLinkURL: "".concat(file.url),
                clickInternalLinks: "true",
                fileNameAndFileType: getTechnicalFileName(file)
            };
        } else {
            return {
                eventAction: "search results:technical:main content area:download",
                eventName: "search results:technical:main content area:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: getTechnicalFileName(file),
                internalLinkPosition: "search results",
                internalLinkType: "search results:technical info",
                internalLinkZoneName: "search results:technical:main content area",
                internalLinkURL: "".concat(file.url),
                clickInternalLinks: "true",
                fileNameAndFileType: getTechnicalFileName(file)
            };
        }
    };
    const getInstallationSupportDownloadEventInfo = (status, message, file, url)=>{
        if (page === "technicalspecs") {
            return {
                eventAction: "technical specs:main content area:installation and support:download",
                eventName: "technical specs:main content area:installation and support:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: getInstallationFileNames(file),
                internalLinkPosition: "technical specs",
                internalLinkType: "technical specs:download",
                internalLinkZoneName: "technical specs:installation and support",
                internalLinkURL: "".concat(file.url),
                clickInternalLinks: "true",
                fileNameAndFileType: getInstallationFileNames(file)
            };
        } else {
            return {
                eventAction: "search results:technical:main content area:download",
                eventName: "search results:technical:main content area:download",
                eventType: "navigation",
                eventMsg: message || "n/a",
                eventStatus: status || "n/a",
                internalLinkName: getInstallationFileNames(file),
                internalLinkPosition: "search results",
                internalLinkType: "search results:installation & service parts",
                internalLinkZoneName: "search results:technical:main content area",
                internalLinkURL: "".concat(file.url),
                clickInternalLinks: "true",
                fileNameAndFileType: getInstallationFileNames(file)
            };
        }
    };
    const handleDownload = (sel, type)=>{
        setLoading(true);
        const files = sel.map((param)=>{
            let { url =""  } = param;
            return url;
        });
        if ((files === null || files === void 0 ? void 0 : files.length) === 1) {
            try {
                window.open(files[0]);
                addDownloadFilesAnalytics(type, "success");
            } catch (error) {
                addDownloadFilesAnalytics(type, "failure", "download failed");
            }
            setLoading(false);
        } else if ((files === null || files === void 0 ? void 0 : files.length) > 1) {
            (0,helper/* handleZipDownload */.G12)(files, sku, ()=>{
                setLoading(false);
                addDownloadFilesAnalytics(type, "success");
            }, ()=>{
                setLoading(false);
                addDownloadFilesAnalytics(type, "failure", "download failed");
            });
        }
    };
    const designFilesLength = designFiles.twoDimension.plan.length + designFiles.twoDimension.front.length + designFiles.twoDimension.side.length + designFiles.threeDimension.length + designFiles.bim.length + designFiles.cutout.length;
    const handleDownloadOfInstallFiles = (item)=>{
        const { url , type , title  } = item;
        if (url) window.open(url.trim(), "_blank");
        addDownloadFilesAnalytics("installation", "success", "", {
            type,
            title,
            url
        });
    };
    const closeModal = ()=>{
        setPartsModal({
            show: false,
            id: ""
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            techFiles.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                isOpen: collapse["technical"],
                handleOpen: ()=>handleCollapse("technical", true),
                handleClose: ()=>handleCollapse("technical", false),
                analyticTitleData: getTechnicalTabAccordionAnalytics(collapse["technical"], "technical info"),
                analyticTitleCustomData: productInfo,
                title: staticTexts.technicalInfo,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "technical-tile__download-section d-flex",
                    "aria-hidden": !collapse.technical,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: "technical-tile__files --technical-info",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "d-block p-0",
                            children: techFiles.map((item, i)=>{
                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: "technical-tile__file",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        onClick: ()=>handleTechInfoDownload(item),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                alt: "",
                                                "aria-hidden": "true",
                                                src: download_dark_gray/* default.src */.Z.src
                                            }),
                                            item.title
                                        ]
                                    })
                                }, i);
                            })
                        })
                    })
                })
            }),
            installFiles.length !== 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                isOpen: collapse["install"],
                handleOpen: ()=>handleCollapse("install", true),
                handleClose: ()=>handleCollapse("install", false),
                analyticTitleData: getTechnicalTabAccordionAnalytics(collapse["install"], staticTexts.installationSupport.toLowerCase()),
                analyticTitleCustomData: productInfo,
                title: staticTexts.installationSupport,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "technical-tile__download-section technical-section-main",
                    "aria-hidden": !collapse.install,
                    children: [
                        installFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "technical-title_sub_title",
                            children: staticTexts.guides
                        }) : null,
                        installFiles.length ? installFiles.map((item, i)=>{
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "technical-tile__files --technical-info m-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "technical-tile__file-type",
                                        role: "link",
                                        onClick: ()=>handleDownloadOfInstallFiles(item),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: pdf_grey/* default.src */.Z.src,
                                                alt: "pdfdownload"
                                            }),
                                            item.title
                                        ]
                                    })
                                })
                            }, i);
                        }) : null,
                        partsFiles.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "technical-title_sub_title part_tile_download",
                            children: staticTexts.partsDiagram
                        }) : null,
                        partsFiles.length ? partsFiles.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "technical-tile__files --technical-info m-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "technical-tile__file-type",
                                        onClick: ()=>{
                                            setPartsModal({
                                                show: true,
                                                id: item.id
                                            });
                                            technicalSpecsServicePartsAnalytics("technical specs", "installation and support", productInfo);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: parts_diagram/* default.src */.Z.src,
                                                alt: "parts"
                                            }),
                                            " ",
                                            item.title
                                        ]
                                    })
                                })
                            }, i)) : null,
                        pdfPartsFiles.length ? pdfPartsFiles.map((item, i)=>/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "technical-tile__files --technical-info m-right",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                        className: "technical-tile__file-type",
                                        onClick: (e)=>handlePdfDownload(e, item.id, item.title),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                src: parts_diagram/* default.src */.Z.src,
                                                alt: "parts"
                                            }),
                                            " ",
                                            item.title
                                        ]
                                    })
                                })
                            }, i)) : null
                    ]
                })
            }),
            !(designFiles.twoDimension.plan.length === 0 && designFiles.twoDimension.front.length === 0 && designFiles.twoDimension.side.length === 0 && designFiles.threeDimension.length === 0) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                isOpen: collapse["design"],
                handleOpen: ()=>handleCollapse("design", true),
                handleClose: ()=>handleCollapse("design", false),
                analyticTitleData: getTechnicalTabAccordionAnalytics(collapse["design"], "design files"),
                analyticTitleCustomData: productInfo,
                title: staticTexts.designFiles,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "technical-tile__download-section",
                    "aria-hidden": !collapse.design,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("section", {
                            className: "technical-tile__select-all",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                tabIndex: collapse["design"] ? 0 : -1,
                                value: staticTexts.selectAll,
                                checked: designFilesLength > 0 && dwgFiles.length === designFilesLength,
                                onChange: (e)=>handleDesignSelectAll(e.target.checked),
                                disabled: !designFilesLength
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                            role: "button",
                            size: "small",
                            loading: loading,
                            onClick: ()=>handleDownload(dwgFiles, "design"),
                            flexible: true,
                            label: "".concat(staticTexts.download, " ").concat(dwgFiles.length > 0 ? dwgFiles.length + " " + (dwgFiles.length === 1 ? staticTexts.file : staticTexts.files) : ""),
                            disabled: dwgFiles.length === 0
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "technical-tile__files",
                            children: [
                                designFiles.twoDimension.plan.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: _2D_plan/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.twoDplan
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list",
                                            children: designFiles.twoDimension.plan.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "2D plan ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "2d plan:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                designFiles.twoDimension.front.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: _2D_front/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.twoDfront
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list",
                                            children: designFiles.twoDimension.front.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "2D Front ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "2d front:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                designFiles.twoDimension.side.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: _2D_side/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.twoDside
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list",
                                            children: designFiles.twoDimension.side.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "2D side ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "2d side:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                designFiles.threeDimension.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: _3D/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.threeDfile
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list input-group",
                                            children: designFiles.threeDimension.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "3D File ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "3d file:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                designFiles.bim.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: _3D_BIM/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.bimFile
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list",
                                            children: designFiles.bim.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "BIM ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "bim:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                }),
                                designFiles.cutout.length > 0 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("section", {
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                            className: "technical-tile__file-type",
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                                    alt: "",
                                                    "aria-hidden": "true",
                                                    src: cutout/* default.src */.Z.src
                                                }),
                                                " ",
                                                staticTexts.cutoutTemplate
                                            ]
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                            className: "checkbox-list",
                                            children: designFiles.cutout.map((item, i)=>{
                                                return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                        tabIndex: collapse["design"] ? 0 : -1,
                                                        checkBoxAria: "Cutout Template ".concat(item.type),
                                                        value: item.type,
                                                        checked: dwgFiles.find((f)=>f.id === item.id) ? true : false,
                                                        onChange: (e)=>handleDesignSelect(e.target.checked, item, "cutout template:".concat(item.type))
                                                    })
                                                }, i);
                                            })
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                })
            }),
            partsModal.show && /*#__PURE__*/ (0,jsx_runtime.jsx)(PartsViewer/* default */.Z, {
                page: page + " results",
                productId: data["ProductProductNo_s"],
                partId: partsModal.id,
                showModal: partsModal.show,
                onClose: ()=>closeModal(),
                analyticsCustomData: productInfo
            })
        ]
    });
};
/* harmony default export */ var TechnicalTile_TechAccordion = (TechAccordion);

// EXTERNAL MODULE: ./src/components/Search/v1/TechnicalTile/index.module.scss
var index_module = __webpack_require__(71470);
var index_module_default = /*#__PURE__*/__webpack_require__.n(index_module);
;// CONCATENATED MODULE: ./src/components/Search/v1/TechnicalTile/index.jsx














const TechnicalTile = (props)=>{
    var ref;
    const { data , currFilters , page , fullWidth , staticTexts , highlightText , t  } = props;
    const { share ="" , certifications: certificationsTxt = "" , collection: collectionTxt = "" , category: categoryTxt = "" , discontinuedText =""  } = staticTexts;
    const [width] = (0,useWindowResize/* default */.Z)();
    const [showSocialLink, setShowSocialLink] = (0,react.useState)(false);
    const persona = (0,helper/* getUserPersona */.shu)();
    // get product details
    const masterSKU = get_default()(data, "masterSKU_s", "");
    const sku = masterSKU;
    const discontinued = get_default()(data, "productRegionAllVariantDiscontinued_b", "");
    const discontinuedDate = get_default()(data, "RegionDiscontinuedDate_dt", "");
    const productName = get_default()(data, "productName_s", "");
    const brandName = get_default()(data, "ProductBrandName_s", "");
    const category = get_default()(data, "Product_Category", "");
    const collection = get_default()(data, "ProductBrandNameDisplay_s", "");
    const description = get_default()(data, "ProductDescriptionProductShort_s", "");
    const watersense = get_default()(data, "ProductSustainability_s", "");
    const adaCompliant = get_default()(data, "ProductADACompliant_s", "");
    const [pdpUrl, setpdpUrl] = (0,react.useState)("");
    (0,react.useEffect)(()=>{
        (0,helper/* getPDPUrl */.ir5)(category, data.slug_s).then((ret)=>setpdpUrl(ret));
    }, [
        data
    ]);
    const badgeVal = get_default()(data, "priceList.".concat(persona, ".saleOffer_s"), "");
    const discountedPrice = get_default()(data, "priceList.".concat(persona, ".finalPrice_d"), 0);
    const price = get_default()(data, "priceStartingAt.".concat(persona, "_d"), 0);
    const isDiscountedPrice = get_default()(data, "priceList.".concat(persona, ".discountedPrice_d"), 0);
    const discountPercent = badgeVal && isDiscountedPrice ? 100 - Math.round(isDiscountedPrice / price * 100) : 0;
    const discountPriceState = badgeVal && isDiscountedPrice ? "percentOff|" + discountPercent : "regular price";
    const productIsRetail = get_default()(data, "ProductIsRetail", "") === "true" ? true : false;
    const isSuperSku = get_default()(data, "comboSKUAvailable_b", null) ? true : false;
    const discountAmount = discountPercent ? Number((price - isDiscountedPrice).toFixed(2)) : 0;
    const productSaleable = productIsRetail ? false : true;
    const productRoom = get_default()(data, "category1_s", "n/a");
    const productCollectionsName = get_default()(data, "ProductBrandNameDisplay_s", "n/a");
    const tileTitle = get_default()(data, "Tile_Title", "");
    const productStatus = discontinued && discontinuedDate && Date.parse(discontinuedDate) < Date.now() ? "out of stock" : "in stock";
    // check for product images
    let imageUrl = "";
    if (data["Color.".concat(persona, ".Details_ss")] && data["Color.".concat(persona, ".Details_ss")].length && currFilters) {
        const colorFilter = currFilters.find((q)=>q.facet === "Color.Finish" || q.facet === "Color" || q.facet === "Finish");
        const selColors = colorFilter === null || colorFilter === void 0 ? void 0 : colorFilter.value;
        if ((selColors === null || selColors === void 0 ? void 0 : selColors.length) > 0) {
            const color = selColors[0];
            const productVariantImages = data["Color.".concat(persona, ".Details_ss")];
            let colorVariants = productVariantImages.find((img)=>{
                const imgDetails = img.split("|");
                return color === imgDetails[1];
            });
            if (colorVariants) {
                colorVariants = colorVariants.split("|");
                imageUrl = colorVariants[5];
            }
        }
    }
    if (!imageUrl && data["productImages.url_ss"]) {
        imageUrl = data["productImages.url_ss"][0];
    } else if (!imageUrl) {
        imageUrl = image_missing/* default */.Z === null || image_missing/* default */.Z === void 0 ? void 0 : image_missing/* default.src */.Z.src;
    }
    // check for certificates
    const certificates = [];
    adaCompliant === "Yes" && certificates.push("ADA");
    watersense && certificates.push(watersense);
    let certifications = "";
    certificates.forEach((item, i)=>{
        certifications += item;
        if (i !== certificates.length - 1) certifications += ", ";
    });
    (0,react.useEffect)(()=>{
        var ref;
        (ref = window.wow) === null || ref === void 0 ? void 0 : ref.sync();
    }, []);
    const designFiles = {
        twoDimension: {
            plan: [],
            front: [],
            side: []
        },
        threeDimension: [],
        bim: [],
        cutout: []
    };
    const info = (0,react.useRef)({});
    (0,react.useEffect)(()=>{
        (0,config/* getConfig */.i)().then(async (config)=>{
            const brandName = await get_default()(config, "general.siteName", "");
            info.current = {
                brandName: brandName
            };
        });
    }, []);
    // check for design files
    data["ProductResource.DXFPlanView.resourceFullWebURL_ss"] && designFiles.twoDimension.plan.push({
        type: "DXF",
        url: data["ProductResource.DXFPlanView.resourceFullWebURL_ss"][0],
        id: "2D-plan-DXF"
    });
    data["ProductResource.DWGPlanView.resourceFullWebURL_ss"] && designFiles.twoDimension.plan.push({
        type: "DWG",
        url: data["ProductResource.DWGPlanView.resourceFullWebURL_ss"][0],
        id: "2D-plan-DWG"
    });
    data["ProductResource.DXFFrontView.resourceFullWebURL_ss"] && designFiles.twoDimension.front.push({
        type: "DXF",
        url: data["ProductResource.DXFFrontView.resourceFullWebURL_ss"][0],
        id: "2D-front-DXF"
    });
    data["ProductResource.DWGFrontView.resourceFullWebURL_ss"] && designFiles.twoDimension.front.push({
        type: "DWG",
        url: data["ProductResource.DWGFrontView.resourceFullWebURL_ss"][0],
        id: "2D-front-DWG"
    });
    data["ProductResource.DXFSideView.resourceFullWebURL_ss"] && designFiles.twoDimension.side.push({
        type: "DXF",
        url: data["ProductResource.DXFSideView.resourceFullWebURL_ss"][0],
        id: "2D-side-DXF"
    });
    data["ProductResource.DWGSideView.resourceFullWebURL_ss"] && designFiles.twoDimension.side.push({
        type: "DWG",
        url: data["ProductResource.DWGSideView.resourceFullWebURL_ss"][0],
        id: "2D-side-DWG"
    });
    data["ProductResource.3DDXFSymbol.resourceFullWebURL_ss"] && designFiles.threeDimension.push({
        type: "DXF",
        url: data["ProductResource.3DDXFSymbol.resourceFullWebURL_ss"][0],
        id: "3D-DXF"
    });
    data["ProductResource.3DDWGSymbol.resourceFullWebURL_ss"] && designFiles.threeDimension.push({
        type: "DWG",
        url: data["ProductResource.3DDWGSymbol.resourceFullWebURL_ss"][0],
        id: "3D-DWG"
    });
    data["ProductResource.3DSketchup.resourceFullWebURL_ss"] && designFiles.threeDimension.push({
        type: "SKP",
        url: data["ProductResource.3DSketchup.resourceFullWebURL_ss"][0],
        id: "3D-SKP"
    });
    data["ProductResource.3DOBJ.resourceFullWebURL_ss"] && designFiles.threeDimension.push({
        type: "OBJ",
        url: data["ProductResource.3DOBJ.resourceFullWebURL_ss"][0],
        id: "3D-OBJ"
    });
    data["ProductResource.3D3DS.resourceFullWebURL_ss"] && designFiles.threeDimension.push({
        type: "3DS",
        url: data["ProductResource.3D3DS.resourceFullWebURL_ss"][0],
        id: "3D-3DS"
    });
    data["ProductResource.3DRevit.resourceFullWebURL_ss"] && designFiles.bim.push({
        type: "RFA",
        url: data["ProductResource.3DRevit.resourceFullWebURL_ss"][0],
        id: "RFA"
    });
    data["ProductResource.CutOutDXF.resourceFullWebURL_ss"] && designFiles.cutout.push({
        type: "DXF",
        url: data["ProductResource.CutOutDXF.resourceFullWebURL_ss"][0],
        id: "cutout"
    });
    const getProductNavigationAnalytics = (link)=>{
        if (page === "technicalspecs") {
            return JSON.stringify({
                eventAction: "technical specs:main content area:product navigation",
                eventName: "technical specs:main content area:product navigation",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName),
                internalLinkPosition: "technical specs",
                internalLinkType: "technical specs:navigation",
                internalLinkZoneName: "technical specs:main content area",
                internalLinkURL: (link.indexOf("http") === -1 ? window.location.origin : "") + link,
                clickInternalLinks: "true"
            });
        }
        return JSON.stringify({
            eventAction: "search results product navigation",
            eventName: "search results product navigation",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName),
            internalLinkPosition: "search results",
            internalLinkType: "search results:technical tiles",
            internalLinkZoneName: "search results:technical:main content area",
            internalLinkURL: (link.indexOf("http") === -1 ? window.location.origin : "") + link,
            clickInternalLinks: "true"
        });
    };
    const productInfo = JSON.stringify({
        productInfo: {
            productBrand: (ref = info.current.brandName) === null || ref === void 0 ? void 0 : ref.toLowerCase(),
            description: (0,helper/* sanitizeTextForAnalytics */.T68)(description) || "n/a",
            productID: sku || "n/a",
            productCategory: (0,helper/* sanitizeTextForAnalytics */.T68)(category) || "n/a",
            productName: (0,helper/* sanitizeTextForAnalytics */.T68)(productName) || "n/a",
            productRoom: (0,helper/* sanitizeTextForAnalytics */.T68)(productRoom || category) || "n/a",
            productCollectionsName: (0,helper/* sanitizeTextForAnalytics */.T68)(productCollectionsName || category) || "n/a",
            globalPromotionPrice: discountPercent && discountAmount ? Number((price - discountAmount).toFixed(2)) : price,
            priceState: discountPriceState,
            productBasePrice: price,
            productColor: "n/a",
            productSalePrice: discountedPrice ? discountedPrice : price,
            productSaleable: productSaleable,
            productStatus: productStatus,
            productSuperSku: isSuperSku,
            productTileName: (0,helper/* sanitizeTextForAnalytics */.T68)(tileTitle) || "n/a",
            defaultImageName: imageUrl || "n/a",
            globalOffer: badgeVal ? badgeVal : "n/a",
            globalDiscount: discountPercent ? discountAmount : 0,
            productPartnerBuyNow: productIsRetail,
            pdpType: "regular finished goods",
            productFindingMethod: "n/a",
            productCouponCode: "n/a",
            productCoupondiscount: 0,
            frequency: "n/a",
            isRecommended: "n/a",
            isSendNow: "n/a",
            isSubscription: "n/a",
            quantity: 1,
            ratings: "n/a",
            numberOfReviews: "n/a"
        }
    });
    const shareEventInfo = function() {
        let needsJSON = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
        let eventInfo = {
            eventAction: "search results:technical:main content area:share",
            eventName: "search results:technical:main content area:share",
            eventType: "navigation",
            eventMsg: "n/a",
            eventStatus: "n/a",
            internalLinkName: "share",
            internalLinkPosition: "search results",
            internalLinkType: "search results:share",
            internalLinkZoneName: "search results:technical:main content area",
            internalLinkURL: "n/a",
            clickInternalLinks: "true"
        };
        if (page === "technicalspecs") {
            eventInfo = {
                eventAction: "technical specs:main content area:share",
                eventName: "technical specs:main content area:share",
                eventType: "navigation",
                eventMsg: "n/a",
                eventStatus: "n/a",
                internalLinkName: "share",
                internalLinkPosition: "technical specs",
                internalLinkType: "technical specs:share",
                internalLinkZoneName: "technical specs:main content area",
                internalLinkURL: "n/a",
                clickInternalLinks: "true"
            };
        }
        if (needsJSON) {
            eventInfo.custom = productInfo;
            return eventInfo;
        }
        return JSON.stringify(eventInfo);
    };
    const handleShare = (e)=>{
        e.stopPropagation();
        e.preventDefault();
        setShowSocialLink(true);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: (index_module_default()).technicalTileWrapper,
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
            className: "technical-tile ".concat(fullWidth ? "--full-width technical-tile__grid-hidefilter" : "technical-tile__grid-showfilter", " wow animate__fadeInUp"),
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "technical-tile__image position-relative",
                    children: [
                        width <= 992 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__add-share--mobile gbh-data-layer",
                            "data-gbh-data-layer-custom": productInfo,
                            "data-gbh-data-layer": shareEventInfo()
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__add-share gbh-data-layer",
                            "data-gbh-data-layer-custom": productInfo,
                            "data-gbh-data-layer": shareEventInfo(),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("span", {
                                tabIndex: "0",
                                role: "button",
                                "aria-label": t("kf.plp.label.share", {
                                    val: productName
                                }),
                                onClick: handleShare,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                        tabIndex: "0",
                                        role: "button",
                                        "aria-hidden": true,
                                        src: icons_share/* default.src */.Z.src,
                                        alt: share
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: "share-section",
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductSocialShare/* default */.Z, {
                                            showModal: showSocialLink,
                                            id: "kf-technical-tile-".concat(data.id),
                                            onClose: ()=>setShowSocialLink(false),
                                            analyticData: shareEventInfo(true),
                                            disableInstagram: true,
                                            url: pdpUrl
                                        })
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: pdpUrl,
                            "data-gbh-data-layer": getProductNavigationAnalytics(pdpUrl),
                            "data-gbh-data-layer-custom": productInfo,
                            className: "d-block technical-tile__image--product-image gbh-data-layer",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("img", {
                                    src: imageUrl,
                                    alt: productName
                                })
                            })
                        })
                    ]
                }),
                width <= 992 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "technical-tile__details",
                    children: [
                        discontinued && discontinuedDate && Date.parse(discontinuedDate) < Date.now() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__badge",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "technical-tile__discontinued",
                                children: discontinuedText
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                            href: pdpUrl,
                            className: "gbh-data-layer",
                            "data-gbh-data-layer": getProductNavigationAnalytics(pdpUrl),
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                children: brandName
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__brand-description",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                text: description,
                                highlight: highlightText
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__sku",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                children: sku
                            })
                        })
                    ]
                }) : null,
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: "technical-tile__collapsible ".concat(fullWidth ? "technical-tile__collapsible-fullWidth-grid" : "technical-tile__collapsible-grid"),
                    children: [
                        width > 992 && discontinued && discontinuedDate && Date.parse(discontinuedDate) < Date.now() ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "technical-tile__badge",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                                className: "technical-tile__discontinued",
                                children: discontinuedText
                            })
                        }) : null,
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: "technical-tile__specs-container",
                            children: [
                                width > 992 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: "technical-tile__details",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                                            href: pdpUrl,
                                            className: "gbh-data-layer",
                                            "data-gbh-data-layer": getProductNavigationAnalytics(pdpUrl),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("h3", {
                                                children: brandName
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "technical-tile__brand-description",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Highlight/* default */.Z, {
                                                text: description,
                                                highlight: highlightText
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "technical-tile__sku",
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                children: sku
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: "technical-tile__add-share--mobile gbh-data-layer",
                                            "data-gbh-data-layer-custom": productInfo,
                                            "data-gbh-data-layer": shareEventInfo()
                                        })
                                    ]
                                }) : null,
                                !(designFiles.twoDimension.plan.length === 0 && designFiles.twoDimension.front.length === 0 && designFiles.twoDimension.side.length === 0 && designFiles.threeDimension.length === 0) ? /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                        className: "technical-tile__specs",
                                        children: [
                                            category ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-subtitle",
                                                        role: "heading",
                                                        "aria-level": "4",
                                                        children: categoryTxt
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-content",
                                                        children: category
                                                    })
                                                ]
                                            }) : null,
                                            collection ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-subtitle",
                                                        role: "heading",
                                                        "aria-level": "4",
                                                        children: collectionTxt
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-content",
                                                        children: collection
                                                    })
                                                ]
                                            }) : null,
                                            certificates.length > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-subtitle",
                                                        role: "heading",
                                                        "aria-level": "4",
                                                        children: certificationsTxt
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                        className: "technical-tile__specs-content",
                                                        children: certifications
                                                    })
                                                ]
                                            }) : null
                                        ]
                                    })
                                }) : null
                            ]
                        }),
                        width <= 992 || width > 1140 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalTile_TechAccordion, {
                                ...props,
                                sku: sku,
                                designFiles: designFiles,
                                productInfo: productInfo
                            })
                        }) : null
                    ]
                }),
                width > 992 && width <= 1140 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "technical-tile__collapsible wide-collapsible technical-tile__collapsible-fullWidth-grid",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TechnicalTile_TechAccordion, {
                        ...props,
                        sku: sku,
                        designFiles: designFiles,
                        productInfo: productInfo
                    })
                }) : null
            ]
        })
    });
};
/* harmony default export */ var v1_TechnicalTile = ((0,es/* withTranslation */.Zh)()(TechnicalTile));


/***/ }),

/***/ 28077:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inspirationWrapper":"InspirationTab_inspirationWrapper__BP8Nl","product-listing__row":"InspirationTab_product-listing__row__62GFD","d-block":"InspirationTab_d-block__lmI2f"};

/***/ }),

/***/ 71470:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"technicalTileWrapper":"TechnicalTile_technicalTileWrapper__dhgAR"};

/***/ }),

/***/ 68993:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inspirationTileWrapper":"InspirationTile_inspirationTileWrapper__0aeUd"};

/***/ }),

/***/ 48162:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"accordionWrapper":"Accordion_accordionWrapper__q7CiR"};

/***/ })

}]);